import { Component, ElementRef, forwardRef, Input } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  UntypedFormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
  Validators,
} from '@angular/forms';
import { getErrorMessage, isEmpty, isNotEmpty } from '@cores/utils/functions';
import { TranslateService } from '@ngx-translate/core';
import { isNull } from 'lodash';

@Component({
  selector: 'lp-input-phone',
  templateUrl: './lp-input-phone.component.html',
  styleUrls: ['./lp-input-phone.component.scss'],
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => LPInputPhoneComponent),
      multi: true,
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LPInputPhoneComponent),
      multi: true,
    },
  ],
})
export class LPInputPhoneComponent implements Validator, ControlValueAccessor {
  @Input() label: string = 'EMPTY';
  @Input() placeholder: string = 'EMPTY';
  @Input() showLabel: boolean = true;
  @Input() pattern: string = '^(0?)(3[2-9]|5[6|8|9]|7[0|6-9]|8[0-7|8|9]|9[0-4|6-9])[0-9]{7}$';
  @Input() required?: boolean | string;
  @Input() readonly: boolean = false;
  @Input() disabled: boolean = false;
  @Input() border: boolean = true;
  @Input() useGrouping: boolean = true;
  @Input() suffix: string = '';
  @Input() prefix: string = '';
  absControl!: AbstractControl;
  control = new UntypedFormControl(null);
  validators: any;
  asyncValidators: any;
  hasChanged: boolean = false;
  initialValue: any;

  constructor(private el: ElementRef<HTMLElement>, private translate: TranslateService) {
    this.control.valueChanges.subscribe(value => {
      if (this.onChange) {
        if (this.hasChanged) {
          //Check xem đây có phải lần onChange đầu tiên không, nếu là lần đầu thì cần check empty để tránh validate value khởi tạo
          this.onChange(value);
        } else {
          if (value === this.initialValue || isNull(value)) {
            return;
          }
          this.hasChanged = true;
          this.onChange(value);
        }
      }
    });
  }

  get errors() {
    return (
      (this.el.nativeElement.closest('.ng-submitted') || this.absControl?.touched || this.absControl?.dirty) &&
      this.absControl?.errors &&
      !this.readonly
    );
  }

  onInput(event: any) {
    this.absControl?.patchValue(event.value);
    this.onChange(event.value);
  }

  onChange = (value: number) => {};

  onTouched = () => {};

  //Lấy ra message lỗi validate để hiển thị, nếu có nhiều lỗi -> hiển thị lỗi đầu tiên.
  getError() {
    let errorKey = Object.keys(this.absControl.errors as object)[0];
    let errorValue: any = this.absControl.errors![errorKey];
    return getErrorMessage(errorKey, errorValue, this.translate.instant(this.label));
  }

  //Dùng để check trường hiện tại có phải required hay không.
  checkRequire() {
    return this.absControl?.hasValidator(Validators.required);
  }

  writeValue(value: number): void {
    this.initialValue = value;
    this.control.setValue(value);
    if (this.absControl) {
      this.absControl.markAsPristine();
    }
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    if (isDisabled) {
      this.control.disable({ emitEvent: false });
    } else {
      this.control.enable();
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    this.absControl = control;
    if (this.control.value) {
      if (this.control.value.match(this.pattern) && isNotEmpty(this.control.value)) {
        return null;
      } else if (isEmpty(this.control.value)) {
        return null;
      } else {
        return { phonePattern: { actualValue: control.value } };
      }
    } else {
      return null;
    }
  }
}
